module.exports = "/_next/static/images/x-duotone-7dd577644f631d35089526d151373b82.svg";